import React from "react";
import { useField } from "formik";
import { useDispatch } from "react-redux";

// material
import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  FormLabel,
  RadioGroup,
  Radio,
  Typography,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";

// ----------------------------------------------------------------------

export default function UploadFormInfo(props) {
  const dispatch = useDispatch();

  const {
    formField: { statementReportGuideline }
  } = props;

  const [statementReportGuidelineField, statementReportGuidelineMeta] =
    useField(statementReportGuideline);

  return (
    <Page title="PART: Grade/Progress/Final Report">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Report Guideline</Typography>
        </Box>
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <Typography variant="body1">
            The submission of reports is one of the responsibilities accepted by
            C2F postdoc grantees.
          </Typography>

          <Typography variant="subtitle1">
            This C2F Progress report/final report can be used for 5 purposes:
          </Typography>

          <List>
            <ListItem>
              <ListItemText
                primary="1. 6 months progress report "
                primaryTypographyProps={{ variant: "subtitle1" }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="2. 11 months progress report with requesting extension period"
                primaryTypographyProps={{ variant: "subtitle1" }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="3. 11 months progress report  (Final report)"
                primaryTypographyProps={{ variant: "subtitle1" }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="4. Progress report for every 3 or 6 month after requesting extension period"
                primaryTypographyProps={{ variant: "subtitle1" }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="5. Final Progress Report (Before or After 11 months)"
                primaryTypographyProps={{ variant: "subtitle1" }}
              />
            </ListItem>
          </List>

          <Typography variant="subtitle1">
            **For those who fill for final report (3, 5), please inform whether
            you want to renew the C2F scholarship contract again.
          </Typography>

          <Typography variant="body1">
            The output of the C2F postdoctoral fellowship for one year contract
            is a research publication in the Top 10 percent of journal ranking
            (Tier 1) which requires to fullfil the conditions as follows:
          </Typography>

          <List>
            <ListItem>
              <ListItemText primary="1. Publication status: Being accepted or published" />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="2. Tier 1 Database: 3 international journal ranking database -Scimago (SJR), CiteScore (Scopus), and 
                Journal Citation Report (Web of Science)."
              />
            </ListItem>
            <ListItem>
              <ListItemText primary="3. Postdoc authorship: First author" />
            </ListItem>
            <ListItem>
              <ListItemText primary="4. Postdoc affiliation: Chulalongkorn University" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5. Mentor authorship: Corresponding author" />
            </ListItem>
            <ListItem>
              <ListItemText primary="6. Top 100 Professor authorship*: Co-author" />
            </ListItem>
            <ListItem>
              <Typography sx={{ color: "#AAAAAA" }}>
                (*Obligatory for a postdoc who receives conducting research
                abroad scholarship from C2F)
              </Typography>
            </ListItem>
            <ListItem>
              <ListItemText primary="7. Acknowledgement C2F fellowship: As indicated in the contract “This research project is supported by the Second Century Fund (C2F), Chulalongkorn University” " />
            </ListItem>
          </List>

          <FormControl fullWidth sx={{ paddingLeft: 2 }}>
            <Typography variant="subtitle2">
              Have you read entire statement in report guideline? *
            </Typography>
            <RadioGroup
              row
              name={statementReportGuidelineField.name}
              value={statementReportGuidelineField.value}
              onChange={(e) => statementReportGuidelineField.onChange(e)}
            >
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label="Yes, I have read and accepted."
              />
              <FormControlLabel
                value="no"
                control={<Radio />}
                label="No, I haven't accepted."
              />
            </RadioGroup>
            {statementReportGuidelineMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px"
                }}
              >
                {statementReportGuidelineMeta.error}
              </span>
            )}
          </FormControl>
        </Stack>
      </Container>
    </Page>
  );
}
